module.exports = __webpack_public_path__ + "img/glasstype-single.1dc264bd.svg";